import { FlowComponent } from '../../../flow.min.js';
import styles from '../flow-input/styles.js'; // Reutilizamos los estilos del input base
import { ValidatorMixin } from '../flow-input/validator.mixin.js';
import currency from '../../../currency.min.js';
const template = FlowComponent.html`
    <div class="mb-4">
        <label class="block text-sm font-medium text-graphite-600 mb-1">${'label'}</label>
        <div class="relative">
            <span class="absolute left-3 top-3 text-graphite-400 font-medium select-none">${'symbol' || '$'}</span>
            <input
                type="text"
                name="${'name'}"
                placeholder="${'placeholder'}"
                ?disabled="${'disabled'}"
                class="appearance-none rounded-lg block w-full pl-6 pr-3 py-3 border border-graphite-300 placeholder-graphite-400 text-ink-black-500 focus:outline-none focus:ring-2 focus:ring-brilliant-azure-500 focus:border-brilliant-azure-500 sm:text-sm invalid:border-red-500 invalid:text-red-900 focus:invalid:border-red-500 focus:invalid:ring-red-500 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
            >
        </div>
        <!-- Slot opcional para mensajes de error custom si no usamos los nativos -->
        <p class="mt-1 text-sm text-red-600 hidden peer-invalid:block"></p>
    </div>
`;

export class FlowPrice extends ValidatorMixin(FlowComponent) {
    static formAssociated = true;
    #internals;

    static get observedAttributes() {
        return ['label', 'name', 'value', 'placeholder', 'disabled', 'required', 'symbol'];
    }

    constructor() {
        super();
        this.#internals = this.attachInternals();
    }

    static get styles() { return styles; }
    static get template() { return template; }

    onMount() {
        super.onMount();

        if (!this.hasAttribute('symbol')) {
            this.setAttribute('symbol', '$');
        }

        const input = this.root.querySelector('input');
        
        // 1. Sincronización básica
        const syncValidity = () => {
            // Internamente guardamos el valor matemático
            const mathValue = currency(input.value).value;
            this.setAttribute('value', mathValue);
            this.#internals.setFormValue(mathValue);
            
            if (!input.checkValidity()) {
                this.#internals.setValidity(input.validity, input.validationMessage, input);
            } else {
                this.#internals.setValidity({});
            }
        };

        // 2. UX: Al enfocar, mostrar el número limpio para fácil edición
        input.addEventListener('focus', () => {
            if (input.value) {
                // Si el valor es "0", lo limpiamos para facilitar la escritura
                const val = currency(input.value).value;
                input.value = val === 0 ? '' : val;
            }
        });

        // 3. UX: Al salir, formatear bonito
        input.addEventListener('blur', () => {
            if (input.value) {
                // Formateamos visualmente ej: 1,250.00
                input.value = currency(input.value).format({ symbol: '' });
            }
            syncValidity();
        });

        input.addEventListener('input', syncValidity);
        
        // Inicializar si hay valor
        const initialVal = this.getAttribute('value');
        if (initialVal) {
            input.value = currency(initialVal).format({ symbol: '' });
            this.#internals.setFormValue(currency(initialVal).value);
        }
    }

    formResetCallback() {
        const initialValue = this.getAttribute('value') || '';
        this.value = initialValue;
        this.#internals.setFormValue(initialValue ? currency(initialValue).value : '');
    }

    get value() {
        const rawValue = this.root.querySelector('input')?.value || 0;
        return currency(rawValue).value;
    }

    set value(val) {
        const input = this.root.querySelector('input');
        if (input) {
            input.value = (val !== null && val !== '') ? currency(val).format({ symbol: '' }) : '';
            input.dispatchEvent(new Event('input', { bubbles: false }));
        }
        this.setAttribute('value', val);
    }
}

customElements.define('flow-price', FlowPrice);
